import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import { DATETIME_FORMAT, TIME_FORMAT } from "../../sharedCode/metadata";
import { CONTROL_MARGIN } from "../../MuiThemes";
import { getHelperText, propertyHasErrors } from "./inputHelpers";
import { HasValue } from "../../sharedCode/HelperMethods";
import { TimeCustomControlProps } from "../../Utils/Interfaces";

export default function TimeEditorNative(props: TimeCustomControlProps): JSX.Element {
    const [inputValue, setInputValue] = useState(getInitialState());

    return (
        <>
            <TextField
                type={"time"}
                margin={CONTROL_MARGIN}
                fullWidth
                label={props.labelText}
                value={inputValue ?? ""}
                onChange={(e) => {
                    handleOnChange(e.target.value);
                }}
                InputProps={{ sx: { padding: 2 } }}
                inputProps={{
                    autoComplete: "off",
                }}
                error={propertyHasErrors(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
                helperText={getHelperText(props.errors, props.containerUrl, props.sourceId, props.sourceProperty)}
            />
        </>
    );

    function getInitialState() {
        const dayJsValue = props.initialValue != null ? dayjs(props.initialValue) : null;
        const inputValue = (dayJsValue?.isValid() ? dayJsValue?.format(TIME_FORMAT) : props.initialValue) || "";

        return inputValue;
    }

    function handleOnChange(timeString: string): void {
        setInputValue(timeString);
        const valueAsDayjs = convertToDayjs(timeString);

        const valueToStore = valueAsDayjs.isValid() ? valueAsDayjs.toISOString() : HasValue(timeString) ? timeString : undefined;
        if (valueToStore !== props.initialValue) {
            props.mergeChanges(props.sourceId, { [props.sourceProperty]: valueToStore });
        }
    }

    function convertToDayjs(time: string): dayjs.Dayjs {
        return dayjs(`${props.documentDate} ${time}`, DATETIME_FORMAT);
    }
}
